<template>
  <v-container v-if="studentInfo">
    <div>
      <component :is="isCompo" :sendCaptureRespos="sendCaptureRespos"> </component>
      <!-- <receipt-invoice></receipt-invoice> -->
    </div>
    <div v-if="studentInfo">
      <v-row key="3">
        <v-col cols="12">
          <template>
            <v-row>
              <v-col cols="12" lg="12" sm="12">
                <v-data-table :headers="headers" sort-by hide-default-footer :items-per-page="-1" :items="feeTypeGroup"
                  class="elevation-1">
                  <template v-slot:top>
                    <v-toolbar flat color="white">
                      <v-toolbar-title class="d-flex justify-center">Transactions</v-toolbar-title>
                      <v-row class="justify-end" v-if="!totalamountDueTillDate == 0">
                        <v-tooltip top>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn v-bind="attrs" v-on="on" class="px-2 ml-1 ma-1" depressed small> Consolidated Fee
                              Receipt </v-btn>
                          </template>
                          <span>This page cannot be accessed since the previous dues have not been cleared.</span>
                        </v-tooltip>
                      </v-row>
                      <v-row class="justify-end" v-else>
                        <v-btn @click="dialogOpen()" class="px-2 ml-1 ma-1" depressed small color="primary">
                          Consolidated Fee Receipt </v-btn>
                      </v-row>
                    </v-toolbar>
                  </template>
                  <template v-slot:item.actions="{ item }">
                    <v-icon small @click="printInvoice(item)">
                      mdi-printer
                    </v-icon>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
            <v-dialog v-model="dialog" max-width="500px">
              <v-card>
                <v-card-title>
                  Consolidated Fee Receipt
                </v-card-title>
                <v-card-text>
                  <v-autocomplete placeholder="Select academic year" label="Academic Year" name="aySelect"
                    v-model="selectedayID" required item-value="id" :items="academicYears" key="id"
                    item-text="academicYear"></v-autocomplete>
                  <span v-if="isNoInfo" class="red--text">No records were found for the academic year. Select a different
                    year and try
                    again.</span>
                </v-card-text>
                <v-card-actions>
                  <v-btn color="primary" text @click="onCloseButton(), dialog = false">
                    Cancel
                  </v-btn>
                  <v-btn color="primary" text @click="getFeeReceiptDataByAcademicYearID()">
                    Proceed
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </template>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>
<script>
import constants from '@/utils/constants'
import ReceiptInvoice from '../Admission/invoice.vue'
import ConsolidatedReceiptInvoice from '../Acad/ConsolidatedFeesReceipt.vue'
// import VueHtmlToPaper from 'vue-html-to-paper'
import _ from 'lodash'
import moment from 'moment'
// import ThankYou from '../../Fees/payment/thankYou'
// import ErrorPage from '../../Fees/payment/error'

export default {
  name: 'student-transaction',
  components: { ReceiptInvoice, ConsolidatedReceiptInvoice },
  props: ['isAllStudentOrderByID', 'totalamountDueTillDate', 'studentAdmissionID', 'enquiryID', 'isAllStudentOrderByenquiryID', 'enquiryCode'],

  data () {
    return {
      // prtHtml: '',
      // prtHtml1: '',
      headers: this.getHeaders(),
      tots_image: `${constants.RAZORPAY.TOTS_IMAGE}`,
      paginated: false,

      loadingComponent: null,

      isSelected: '',
      feeSelected: [],
      feeTypeGroup: [],
      sendCaptureRespos: '',

      isCompo: null,
      studentInfo: null,
      dialog: false,
      selectedayID: '',
      academicYears: [],
      isNoInfo: false,
      studentInfoByAyID: null,
      feeTypeGroupByAyID: []

    }
  },
  async created () {
    await this.getAllInfo()
    await this.getAcademicYears()
  },
  beforeDestroy () {
    console.log('Main Vue destroyed')
  },
  watch: {
    selectedayID (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.isNoInfo = false
      }
    }
  },
  methods: {
    printInvoice: async function (printData) {
      try {
        let self = this
        this.loadingComponent = this.$buefy.loading.open()
        let response1 = await http.get(`${constants.API_URL}/api/student-invoice/${printData.id}`)
        this.sendCaptureRespos = response1
        this.isCompo = ReceiptInvoice
        setTimeout(function () {
          self.printHTMLFormat()
        }, 1000)
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        return this.$buefy.dialog.alert({
          type: 'is-danger',
          message: errorMessage,
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',

          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      } finally {
        this.loadingComponent.close()
      }
    },
    printHTMLFormat: function () {
      let studentNames = null
      if (!_.isEmpty(this.studentInfoByAyID)) {
        studentNames = JSON.parse(JSON.stringify(this.studentInfoByAyID))
      }
      if (!_.isEmpty(this.sendCaptureRespos)) {
        if (!_.isEmpty(this.sendCaptureRespos.data)) {
          studentNames = JSON.parse(JSON.stringify(this.sendCaptureRespos.data.enquiryData))
        }
      }
      let options = {}
      options.windowTitle = `FirstCry Intellitots: ${studentNames.studentFirstName}-${studentNames.studentClass.name}-AY${studentNames.franchiseeAcademicYear.academicYear}.pdf`

      if (this.sendCaptureRespos.data) {
        if (this.sendCaptureRespos.data.gstCalculationData.genrateInvoice === 'gstbill') {
          this.$htmlToPaper('printableArea2', options)
        } else if (this.sendCaptureRespos.data.gstCalculationData.genrateInvoice !== 'gstbill') {
          this.$htmlToPaper('printableArea', options)
        }
      } else {
        this.$htmlToPaper('printableArea', options)
      }
      this.$nextTick(() => {
        this.isCompo = ''
      })
    },
    getAllTransactionReport: async function () {
      try {
        let self = this
        let response = {}
        response.studentInfo = this.studentInfoByAyID
        response.paymentOrderData = this.feeTypeGroupByAyID
        this.sendCaptureRespos = response
        if (!_.isEmpty(response.paymentOrderData)) {
          if (typeof response.studentInfo === 'object') {
            this.isCompo = ConsolidatedReceiptInvoice
            setTimeout(function () {
              self.printHTMLFormat()
            }, 1000)
            this.dialog = false
            this.isNoInfo = false
            this.selectedayID = ''
          }
        }
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message

        return this.$buefy.dialog.alert({
          type: 'is-danger',
          message: errorMessage,
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',

          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      } finally {
        this.loadingComponent.close()
      }
    },
    // printHTMLFormat: function () {
    //   // Get HTML to print from element

    //   if (document.getElementById('printableArea') != null || document.getElementById('printableArea1') != null) {
    //     this.prtHtml = document.getElementById('printableArea').innerHTML
    //     // this.prtHtml1 = document.getElementById('printableArea1').innerHTML
    //   }
    //   // Get all stylesheets HTML
    //   let stylesHtml = ''
    //   for (const node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
    //     stylesHtml += node.outerHTML
    //   }

    //   // Open the print window
    //   const WinPrint = window.open('', '', 'left=0,top=0,width=800,height=1300,toolbar=0,scrollbars=0,status=0')

    //   WinPrint.document.write(`<!DOCTYPE html>
    // <html>
    //   <head>
    //     ${stylesHtml}
    //   </head>
    //   <body>
    //     ${this.prtHtml}

    //   </body>
    //   <style>

    //   @media print {
    //     .page-break {
    //         height: 0;
    //         page-break-before: always;
    //         margin: 0;
    //         border-top: none;
    //     }
    // }

    // body, p, a,
    // span, td {
    //     font-size: 9pt;
    //     font-family: Arial, Helvetica, sans-serif;
    // }

    // body {
    //     margin-left: 2em;
    //     margin-right: 2em;
    // }

    // .page {
    //     height: 1300px;
    //     padding-top: 5px;
    //     page-break-after: always;
    //     font-family: Arial, Helvetica, sans-serif;
    //     position: relative;
    //     border-bottom: 1px solid #000;
    // }
    //   </style>

    // </html>`)
    //   WinPrint.document.close()

    //   WinPrint.focus()

    //   setTimeout(function () {
    //     WinPrint.print()
    //   }, 1000)
    //   // WinPrint.onfocus = function () {
    //   //   setTimeout(function () {
    //   //     WinPrint.close()
    //   //   }, 800)
    //   // }

    //  this.$nextTick(() => {
    //    this.isCompo = ''
    //   })
    //  },
    getHeaders () {
      let header = [
        { text: 'Receipt Number', value: 'receiptNo', align: 'center' },
        { text: 'Reference ', value: 'referenceURLType', align: 'center' },
        { text: 'Date ', value: 'createdAt', align: 'center' },
        { text: 'Amount ', value: 'amount', align: 'center' },
        { text: 'Payment Mode ', value: 'paymentMode', align: 'center' },
        { text: 'Payment Method ', value: 'paymentMethod', align: 'center' },
        // { text: 'Order ID ', value: 'orderID', align: 'center' },
        { text: 'Status ', value: 'status', align: 'center' },
        { text: 'Actions', value: 'actions', sortable: false }
      ]

      return header
    },

    getAllInfo: async function () {
      try {
        this.loadingComponent = this.$buefy.loading.open()
        let response
        if (this.isAllStudentOrderByID) {
          response = await http.get(`${constants.API_URL}/api/student-order?admissionID=${this.studentAdmissionID}`)
        } else if (this.isAllStudentOrderByenquiryID) {
          response = await http.get(`${constants.API_URL}/api/student/service/payment?enquiryID=${this.enquiryID}`)
        } else {
          response = await http.get(`${constants.API_URL}/api/student-orders`)
        }
        if (response.data) {
          this.studentInfo = response.data.studentInfo

          this.feeTypeGroup = response.data.paymentOrders
        }
        _.map(this.feeTypeGroup, (obj) => {
          obj.createdAt = obj.createdAt = obj.paymentOfflineDetail
            ? moment(new Date(obj.paymentOfflineDetail.dateOfPayment)).format('DD/MM/YYYY')
            : moment(new Date(obj.createdAt)).format('DD/MM/YYYY')
          obj.amount = obj.amount / 100
          obj.referenceURLType = obj.referenceURLType + ` (` + 'Order ID:' + obj.orderID + ')'
          obj.receiptNo = obj.receiptNo ? obj.receiptNo : 'N/A'
        })
        this.headers = this.getHeaders()
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message

        return this.$buefy.dialog.alert({
          type: 'is-danger',
          message: errorMessage,
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',

          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      } finally {
        this.loadingComponent.close()
      }
    },
    getAcademicYears: async function () {
      try {
        const { data } = await http.get(`${constants.API_URL}/api/franchiseeAcademicYears`)
        this.academicYears = data.rows
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        return this.$buefy.dialog.alert({
          type: 'is-danger',
          message: errorMessage,
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',

          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    },
    getFeeReceiptDataByAcademicYearID: async function () {
      try {
        if (!this.selectedayID) {
          return this.errMsg('Please select academic year first.')
        } else {
          await this.getAllInfoByAcademicYear()
        }
      } catch (e) {
        this.dialog = false
        console.log(e)
      }
    },
    errMsg (msg) {
      return this.$dialog.error({
        text: msg,
        title: 'Error'
      })
    },
    onCloseButton: async function () {
      try {
        this.selectedayID = ''
        await this.getAllInfo()
      } catch (e) {
        console.log(e)
      }
    },
    getAllInfoByAcademicYear: async function () {
      try {
        this.loadingComponent = this.$buefy.loading.open()
        let response
        if (this.isAllStudentOrderByID) {
          response = await http.get(`${constants.API_URL}/api/student-order?admissionID=${this.studentAdmissionID}&&academicYearID=${this.selectedayID}&&enquiryCode=${this.enquiryCode}`)
        } else if (this.isAllStudentOrderByenquiryID) {
          response = await http.get(`${constants.API_URL}/api/student/service/payment?enquiryID=${this.enquiryID}&&academicYearID=${this.selectedayID}`)
        } else {
          response = await http.get(`${constants.API_URL}/api/student-orders?academicYearID=${this.selectedayID}&&enquiryCode=${this.enquiryCode}`)
        }
        if (response.data) {
          this.studentInfoByAyID = response.data.studentInfo

          this.feeTypeGroupByAyID = response.data.paymentOrders
          this.isNoInfo = false
          await this.getAllTransactionReport()
        }
        _.map(this.feeTypeGroupByAyID, (obj) => {
          obj.createdAt = obj.createdAt = obj.paymentOfflineDetail
            ? moment(new Date(obj.paymentOfflineDetail.dateOfPayment)).format('DD/MM/YYYY')
            : moment(new Date(obj.createdAt)).format('DD/MM/YYYY')
          obj.amount = obj.amount / 100
          obj.referenceURLType = obj.referenceURLType + ` (` + 'Order ID:' + obj.orderID + ')'
          obj.receiptNo = obj.receiptNo ? obj.receiptNo : 'N/A'
        })
        if (_.isEmpty(response.data.paymentOrders)) {
          this.isNoInfo = true
        } else if (typeof response.data.studentInfo !== 'object') {
          this.isNoInfo = true
        } else if (_.isEmpty(response.data)) {
          this.isNoInfo = true
        }
      } catch (e) {
        this.isNoInfo = true
        this.loadingComponent.close()
      } finally {
        this.loadingComponent.close()
      }
    },
    dialogOpen () {
      this.dialog = true
      this.selectedayID = ''
      this.isNoInfo = false
    },
    getStudentDetails: async function () {
      try {

      } catch (e) {
        console.log(e)
      }
    }
  }
}
</script>
